export default "__VITE_ASSET__QNJIskkE__"